import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 24px;
`;

export const Subtext = styled.p`
  font: 16px Montserrat;
  font-weight: 400;
  color: #898b8e;
  line-height: 24px;
`;

export const WrapperInfo = styled.div`
  padding-top: 16px;
  padding-bottom: 24px;
`;

export const Heading1 = styled.div`
  img {
    display: inline-block;
    width: 56px;
    height: 56px;
  }

  h1 {
    font: 24px Montserrat;
    font-weight: 600;
    color: #000000;
  }

  p {
    font: 16px Montserrat;
    font-weight: 500;
    color: #555658;
  }

  margin-bottom: 16px;
`;
